import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withFirebase } from '../Firebase';
import DragScrollProvider from 'drag-scroll-provider';
import SinglePoll from './SinglePoll';
import defaultImage from '../../assets/polls/defaultImage.jpg';
import Modal from "react-responsive-modal";
import PropTypes from 'prop-types';
import Fade from '@material-ui/core/Fade';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

import "./LatestPolls.css";
import { AnswerPollContent } from '../AnswerPoll/AnswerPoll';

class LatestPolls extends Component {

    componentDidMount() {
        document.body.style.background = '#F8F9FB';
    }

    render() {
        return (
            <LatestPollsComponent {...this.props} />
        );
    }
}

const INITIAL_STATE = {
    managerID: '',
    visibleCapsules: [],
    visiblePolls: {},
    sortedPolls: [],
    answerPollOpen: false,
    activePollID: '',
    activeCapsuleID: '',
    answerStep: '',
    loading: true,
    error: null,
    myPollsID: []
};

const styles_desktop = {
    overlay: {
        display: "block",
        position: "fixed",
        left: 0,
        top: 0,
        zIndex: 9999,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.79)",
        overflow: "auto",
    },
    modal: {
        boxShadow: 'none',
        borderRadius: '4px',
        minHeight: "684px",
        maxWidth: "376px",
        top: "10%",
        padding: "0px",
    }
};

const styles_mobile = {
    overlay: {
        display: "block",
        position: "fixed",
        left: 0,
        top: 0,
        zIndex: 9999,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.79)",
        overflow: "auto",
        padding: "0px",
    },
    modal: {
        boxShadow: 'none',
        minHeight: "100%",
        width: "100%",
        padding: "0px",
    }
};

const styles_loader = theme => ({
    root: {
        position: 'absolute',
        left: '50%',
    },
    button: {
        margin: theme.spacing.unit * 2,
    },
    progress: {
        color: '#0070A2',
    },
    placeholder: {
        position: 'relative',
        left: '-50%',
        height: 40,
    },
});


class LatestPollsComponentBase extends Component {

    constructor(props) {
        super(props);
        this.state = { ...INITIAL_STATE };
    }

    componentWillReceiveProps(nextProps) {
        this.getVisibleCapsules()
    }

    getVisibleCapsules = async () => {
        this.props.firebase.auth.onAuthStateChanged(async (currentUser) => {

            if (currentUser === null) {
                return
            }

            let querySnapshotUsers = await this.props.firebase.db.collection('users').get();
            let querySnapshotCapsules = await this.props.firebase.db.collection('capsules').get();

            const currentUserInfos = querySnapshotUsers.docs
                .filter(user => user.id === currentUser.uid)
                .map(doc => doc.data())[0] || { manager: '' };
            const managerID = currentUserInfos.manager;

            let visibleCapsules = []
            switch (this.props.page) {
                case 'home':
                    visibleCapsules = querySnapshotCapsules.docs.map(
                        capsule => {
                            const managers = capsule.data().managers
                            if (managers.includes(currentUser.uid) || managers.includes(managerID)) {
                                if (!capsule.data().status) {
                                    return capsule.id //keep capsule without status
                                }
                                return null
                            }
                            else return null
                        })
                    this.getPolls(visibleCapsules)
                    break;
                case 'assigned':
                    visibleCapsules = querySnapshotCapsules.docs.map(
                        capsule => {
                            const managers = capsule.data().managers
                            if (managers.includes(currentUser.uid) || managers.includes(managerID)) {
                                if (this.props.propelledCapsulesIds && this.props.propelledCapsulesIds.includes(capsule.id)) {
                                    return capsule.id //keep assigned capsules
                                }
                                return null
                            }
                            else return null
                        })
                    this.getPolls(visibleCapsules)
                    break;
                default:
                    visibleCapsules = querySnapshotCapsules.docs.map(
                        capsule => {
                            const managers = capsule.data().managers
                            if (managers.includes(currentUser.uid) || managers.includes(managerID)) {
                                if (capsule.data().status === this.props.page) {
                                    return capsule.id //keep capsules with corresponding status
                                }
                                return null
                            }
                            else return null
                        })
                    this.getPolls(visibleCapsules)
            }
            this.setState({ managerID })
        });
    }

    getPolls = async (visibleCapsules) => {
        let visiblePolls = {};
        for (const capsuleID of visibleCapsules) {
            let docCapsule = null
            if (capsuleID !== null) {
                docCapsule = await this.props.firebase.db.collection('capsules').doc(capsuleID).get();
                const querySnapshotPolls = await this.props.firebase.db.collection('capsules/' + capsuleID + '/polls').get();
                for (const poll of querySnapshotPolls.docs) {
                    visiblePolls = {
                        ...visiblePolls,
                        [poll.id]: {
                            pollPicture: docCapsule.data().image_url_capsule || defaultImage,
                            capsuleID: capsuleID,
                            creationDate: poll.data().creationDate,
                            creatorId: poll.data().creatorId,
                            pollTopic: docCapsule.data().tags[0] ? '#' + docCapsule.data().tags[0] : '#noTags',
                            answered: poll.data().collectedUsers ? poll.data().collectedUsers.includes(this.props.firebase.auth.currentUser.uid) : false
                        }
                    }
                }
            }
        }
        let sortedPolls = Object.keys(visiblePolls).map(pollID => {
            return {
                pollID: pollID,
                capsuleId: visiblePolls[pollID].capsuleID,
                creatorId: visiblePolls[pollID].creatorId,
                creationDate: visiblePolls[pollID].answered ? 0 : visiblePolls[pollID].creationDate
            }
        })
        sortedPolls.sort((a, b) => b.creationDate - a.creationDate)
        this.setState({ visiblePolls, sortedPolls, loading: false })
    }

    openAnswerPoll = () => {
        this.setState({
            answerPollOpen: true
        })
    }

    closeAnswerPoll = () => {
        this.setState({
            answerPollOpen: false
        })
    }

    markPollAsAnswered = (pollID) => {
        let visiblePolls = this.state.visiblePolls;
        visiblePolls[pollID].answered = true;
        this.setState({ visiblePolls })
    }

    onClick = async pollID => {
        let visiblePolls = this.state.visiblePolls;
        let activePollID = pollID;
        let activeCapsuleID = visiblePolls[pollID].capsuleID

        if (visiblePolls[pollID].answered) {
            this.setState({ activePollID, activeCapsuleID, answerPollOpen: true, answerStep: 'STEP2' });
        }

        else {
            this.setState({ activePollID, activeCapsuleID, answerPollOpen: true, answerStep: 'STEP1' });
        };
    }

    render() {
        const { classes } = this.props
        const { visiblePolls, activePollID, activeCapsuleID, answerStep, sortedPolls, loading } = this.state;

        return (
            <div>
                <div className="latest-polls-title">
                    Les derniers sondages
                </div>

                <div className="latest-polls-container">
                    <div className={classes.root}>
                        <div className={classes.placeholder}>
                            <Fade
                                in={loading}
                                style={{
                                    transitionDelay: loading ? '0ms' : '0ms',
                                }}
                                unmountOnExit>

                                <CircularProgress className={classes.progress} />
                            </Fade>
                        </div>
                    </div>
                    <Fade in={loading === false}>
                        <div>
                            <DragScrollProvider>
                                {({ onMouseDown, ref }) => (
                                    <div className="latest-polls-scrolling-wrapper"
                                        ref={ref}
                                        onMouseDown={onMouseDown}>

                                        {sortedPolls.length === 0 ?
                                            <div className="latest-polls-empty">
                                                <div className="latest-polls-empty-text">Aucun sondage pour l'instant...</div>
                                            </div> :
                                            sortedPolls.map((value, index) => {
                                                return (

                                                    <SinglePoll key={index}
                                                        onClick={() => this.onClick(value.pollID)}
                                                        src={visiblePolls[value.pollID].pollPicture}
                                                        topic={visiblePolls[value.pollID].pollTopic}
                                                        answered={visiblePolls[value.pollID].answered}
                                                        poll={value}
                                                        pollId={value.pollID}
                                                        capsuleId={value.capsuleId} />
                                                )
                                            })}

                                    </div>
                                )}
                            </DragScrollProvider>
                        </div>
                    </Fade>
                </div>

                <Modal
                    open={this.state.answerPollOpen}
                    onClose={this.closeAnswerPoll}
                    center
                    showCloseIcon={true}
                    styles={(window.innerWidth > 768) ? styles_desktop : styles_mobile}
                >
                    <AnswerPollContent
                        onClose={this.closeAnswerPoll}
                        activePollID={activePollID}
                        activeCapsuleID={activeCapsuleID}
                        answerStep={answerStep}
                        markPollAsAnswered={this.markPollAsAnswered} />

                </Modal>
            </div>
        );
    };
}

LatestPollsComponentBase.propTypes = {
    classes: PropTypes.object.isRequired,
};

const LatestPollsComponent = withRouter(withFirebase(withStyles(styles_loader)(LatestPollsComponentBase)));

export default LatestPolls;
export { LatestPollsComponent };